import { useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

import { useLanguage } from '../../hooks';
import { DatascopeDictionary, QuestionInterface } from '../../types/oldWebForms';
import { ConfirmActionDialog } from '../uiComponents';
import { NavigatorItem } from './questionNavigator';

export const SubformNavigator = (props: {
  callbackSetAdapter: () => void;
  hoveredId: string;
  index: number;
  initialState: boolean;
  isDragging: boolean;
  onHoveredHandler: (id?: string | number) => void;
  onNameChange: (id: string | number, name: string) => void;
  onNameInSectionChange: (id: string | number, name: string) => void;
  onNameInTableChange: (id: string | number, name: string, subformId: string) => void;
  onScrolledIdxHandler: (index: number | string) => void;
  onZoomedHandler: (id: string | number) => void;
  onZoomedInTableHandler: (id: string | number) => void;
  sectionOpen: boolean;
  setInitialState: (value: boolean) => void;
  setSubformStates: (value: DatascopeDictionary<any>) => void; //FIXME: any
  subformEmpty: (subformId: string, firstSubquestionId: string) => void;
  subformId: string;
  subformName: string;
  subformStates: DatascopeDictionary<any>; //FIXME: any
  subQuestionRemove: (
    subformId: string,
    deletedQuestionIndex: number,
    deletedQuestionId: string,
  ) => void;
  subQuestions: QuestionInterface[];
  zoomedId: string;
}) => {
  const {
    index,
    subformId,
    subformName,
    hoveredId,
    onHoveredHandler,
    onNameChange,
    onNameInSectionChange,
    onScrolledIdxHandler,
    onZoomedHandler,
    subQuestions,
    zoomedId,
    isDragging,
    callbackSetAdapter,
    subQuestionRemove,
    subformEmpty,
    setInitialState,
    onZoomedInTableHandler,
    subformStates,
    setSubformStates,
    onNameInTableChange,
  } = props;

  const lang = useLanguage();
  const [confirmEmptyOpen, setConfirmEmptyOpen] = useState(false);

  const handleSubformEmpty = () => {
    subformEmpty(subformId, subQuestions[0].id);
    setConfirmEmptyOpen(false);
  };

  const isZoomed = subformId === zoomedId;
  const isHovered = subformId === hoveredId;
  return (
    <>
      <ConfirmActionDialog
        isOpen={confirmEmptyOpen}
        onClose={() => setConfirmEmptyOpen(false)}
        warningTitle={lang.form_builder.areYouSure}
        warningMessage={lang.form_builder.subformEmptyConfirm}
        onConfirmAction={handleSubformEmpty}
        confirmActionButtonText={lang.form_builder.confirm}
      />
      <NavigatorItem
        key={subformId}
        index={index}
        id={subformId}
        name={subformName}
        type={'table'}
        isZoomed={isZoomed}
        isHovered={isHovered}
        onZoomedHandler={onZoomedHandler}
        onHoveredHandler={onHoveredHandler}
        onScrolledIdxHandler={onScrolledIdxHandler}
        onNameChange={onNameChange}
        onNameInSectionChange={onNameInSectionChange}
        subQuestions={subQuestions}
        isDragging={isDragging}
        dropdownState={subformStates}
        setDropdownState={setSubformStates}
        callbackSetAdapter={callbackSetAdapter}
        handleSubformEmpty={handleSubformEmpty}
        setInitialState={setInitialState}
        setConfirmEmptyOpen={setConfirmEmptyOpen}
      />
      {subformStates[subformId] && (
        <Droppable
          droppableId={`subformDroppable-${subformId}`}
          type={`subform-${subformId}`}
          renderClone={(provided, snapshot, rubric) => {
            const index = rubric.source.index;
            const { id, name, type } = subQuestions[index];
            const isZoomed = id === zoomedId;
            const isHovered = id === hoveredId;
            return (
              <div
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
              >
                <NavigatorItem
                  key={id}
                  index={index}
                  id={id}
                  name={name}
                  type={type}
                  isZoomed={isZoomed}
                  isHovered={isHovered}
                  onZoomedHandler={onZoomedHandler}
                  onHoveredHandler={onHoveredHandler}
                  onScrolledIdxHandler={onScrolledIdxHandler}
                  onZoomedInTableHandler={onZoomedInTableHandler}
                  onNameChange={onNameChange}
                  onNameInTableChange={onNameInTableChange}
                  subQuestions={subQuestions}
                  isDragging={snapshot.isDragging}
                />
              </div>
            );
          }}
        >
          {(provided) => (
            <div ref={provided.innerRef}>
              {subQuestions.map((q: any, i: number) => {
                const isZoomed = q.id === zoomedId;
                const isHovered = q.id === hoveredId;
                return (
                  <Draggable
                    key={q.id}
                    draggableId={q.id}
                    index={i}
                  >
                    {(provided, snapshot) => (
                      <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <NavigatorItem
                          key={q.id}
                          index={i}
                          id={q.id}
                          name={q.name}
                          type={q.type}
                          isZoomed={isZoomed}
                          isHovered={isHovered}
                          onZoomedHandler={onZoomedHandler}
                          onHoveredHandler={onHoveredHandler}
                          onScrolledIdxHandler={onScrolledIdxHandler}
                          onNameChange={onNameChange}
                          onNameInSectionChange={onNameInSectionChange}
                          onNameInTableChange={onNameInTableChange}
                          subQuestions={subQuestions}
                          isDragging={snapshot.isDragging}
                          callbackSetAdapter={callbackSetAdapter}
                          setInitialState={setInitialState}
                          subformIndex={index}
                          subformId={subformId}
                          onZoomedInTableHandler={onZoomedInTableHandler}
                          subQuestionRemove={subQuestionRemove}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      )}
    </>
  );
};
